import React from 'react';
import { useNavigate } from 'react-router';
import { ButtonMain } from 'components';
import { ReportTypeEnum } from 'fragments';
import { Svg, Images } from 'assets';
import { SaveParams } from 'utils';

const insights = [
  {
    text: 'Rental Income Potential (FRV)',
  },

  {
    text: 'Current Market Value (FMV)',
  },

  {
    text: 'Delivered instantly to your inbox',
  },
];

export const BothReports = () => {
  const navigate = useNavigate();

  return (
    <div className='container'>
      <div className='both-reports-wrapper'>
        <div className='both-reports-left-bar'>
          <h2 className='both-reports-left-bar-title'>
            Get More, Pay Less-Bundle Both Reports & Save $49
          </h2>

          <p className='both-reports-left-bar-description'>
            Order both the FRV (Fair Rental Value) and FMV (Fair Market Value) reports together and unlock
            the full picture of your property’s worth - for just $199 (normally $248).
          </p>

          <div className='both-reports-right-insights'>
            {insights.map((insight, index) => (
              <div className='both-reports-right-insight' key={index}>
                <Svg.CheckSvg />
                <p className='both-reports-right-insight-text'>{insight.text}</p>
              </div>
            ))}
          </div>

          <ButtonMain
            text='Get Both Reports & Save'
            className='both-reports-button'
            startAdornment={<Svg.Listing />}
            onClick={() => SaveParams('/order-now', navigate, { reportType: ReportTypeEnum.ALL })}
          />
        </div>

        <div className='both-reports-right-bar'>
          <img src={Images.BothReports} alt='report' />
        </div>
      </div>
    </div>
  );
};

